<template>
  <div class="page-product-table-box">

    <div class="tablebox">
      <el-table 
        :cell-style="getTableCellStyle"
        @sort-change="sortTableList"
        v-loading="tableloading" 
        ref="multipleTable" 
        :data="tableData" 
        tooltip-effect="dark" 
        style="width: 100%" 
        @selection-change="handleSelectionChange"
        size="mini"
      >
        <el-table-column prop='ShopId' label="ShopID" width="80"></el-table-column>
        <el-table-column :label="$t('dsfx.t57')" sortable='custom' prop="ShopName" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 圆 30天以上
            三角 30天以内
            红为本品投诉记录、黄为被其他品牌投诉过 -->
            <i class="icon-shop-warning icon-shop-warning-c-r" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.ismore30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-r" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.is30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-c-y" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.ismore30day/1 === 1 && scope.row.isnotself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-y" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.is30day/1 === 1 && scope.row.isnotself/1 === 1"></i> 
            <!-- isYjdf 一件代发/批发 店铺名高亮色 -->
            <a :href="scope.row.ShopUrl" target="_blank" :class="{ispifa : scope.row.isYjdf/1 === 1 ? true :false }">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dsfx.t20')" sortable='custom' prop="ChannelName" width="100">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.ChannelName"></i>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop='shoplevel' :label="$t('Seller.t11')" width="115">
          <template slot-scope="scope">
            <el-rate
              v-model="scope.row.shoplevel"
              disabled
              text-color="#ff9900"
              score-template="{value}">
            </el-rate>            
          </template>
        </el-table-column>
        <el-table-column prop='ShopLab' :label="$t('jgjk.s211')" sortable='custom' width="100"></el-table-column>
        <el-table-column prop='Authorize' :label="$t('dsfx.t23')" sortable='custom' width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.AuthorizeText }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop='Discount' :label="$t('report.s51')" width="100"></el-table-column>
        <el-table-column v-if="showecommerce" prop="isQinqText" sortable='custom' :label="$t('DashboardProduct.barlegendnamefalse')" width="100"></el-table-column>
        <el-table-column sortable='custom' prop='TotalLink' :label="$t('Seller.t12')" width="80"></el-table-column>
        <el-table-column sortable='custom' prop='SkuTotalAmountStr' :label="$t('jgjk.s244')" width="110"></el-table-column>
        <el-table-column :label="$t('Seller.t13')" sortable='custom' prop="label" width="100">
          <template slot-scope="scope">
            <i 
              class="el-icon-s-flag sellerlistbtn sellerlistbtn-flag" 
              :class="'flagcolor_' + scope.row.label/1" 
              @click="setflag(scope.row.label, scope.row.notes, scope.$index, scope.row.ShopId)">
            </i>
            <i class="el-icon-edit-outline sellerlistbtn" @click="shoptags(scope.row.ShopName, scope.row.label, scope.row.ShopId, scope.row.notes, scope.$index)"></i>
            <button class="btnshopdetail" type="button" @click="viewDetail(scope.row.ShopId)"></button>            
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>

    <!--显示最近10条记录-->
    <el-dialog
      :title="$t('Seller.t14')"
      :visible.sync="showwaring"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%">
      <div style="">
        <el-table :data="shopdetaillist" tooltip-effect="dark" size="mini">
          <el-table-column prop="CreateTime" :label="$t('dsfx.t28')" />
          <el-table-column prop="status" :label="$t('dsfx.t27')" />
        </el-table>
      </div>
    </el-dialog>

    <!-- 填写卖家备注 -->
    <el-dialog
      custom-class="sellertagdialog"
      :title="currentsellername"
      :visible.sync="showshopinfo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="500px">
      <div style="font-size: 14px;" class="sellertaginput">
        <!-- 疑似出售假货，卖假货，盗图商品，非授权商品。。。。 -->
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea"
          resize="none">
        </el-input>        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" size="mini" @click="setnote(currentlabe, textarea, currentshopid)">{{ $t('PageCommon.queding') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: '',
      currentshopid: '',
      currentlabe: '',
      ratevalue: 3.7,
      shopdetaillist: [],
      showwaring: false,
      showshopinfo: false,
      currentsellername: '',
      pagesize: 25,
      dialogTableData: [],
      showdialogtable: false,

      optionsRefresh: true,

      notvip1: JSON.parse(window.localStorage.getItem('status')).val < 1 ? false : true,
      notviptable: false,
      balance: '',

      feedbackcomplaindialog: false,
      userbalance: '',
      feedbackcomplainsuccess: false,

      feedbacksuccess: false,
      feedbackBtnDisable: true,//true:隐藏
      feedbackBtnId: 0,//反馈类型：判定错误/链接失效
      feedbackTextarea: '',//系统反馈内容
      feedbackSelectedIds: '',//反馈的数据ID
      feedbackOptionsval: null,
      feedbackOptions: [],
      feedbackdialogopen: false,//意见反馈对话框是否打开

      tableloading: true,
      viewState: {
          selectedTab: "tab_all",
          searchNeedle: '',
          model4Tab: {}
      },
      tableorder: 50,
      tablepid: 0,
      refresh: false,
      formInline: {
        user: '',
        region: ''
      },
      selectToolsChannel:'',
      selectToolsResult:'',
      selectToolsStatus:'',
      filterSelect:{
        channel : [], //渠道
        result: [],   //判定结果
        status : [],  //确信度
      },
      filters: [
        {
          fieldid: "ChannelName",
          source: "channels",
          options: [],
          default: ''
        },
        {
          fieldid: "level_name",
          source: "level_names",
          options: [],
          default: ''
        },
        {
          fieldid: "ConfidenceLevelBucketName",
          source: "confidences",
          options: [],
          default: ''
        },
      ],
      filterselector: [{
          fieldid: "Channel",
          source: "channel",
          options: [],
          default: ''
      },{
          fieldid: "Result",
          source: "result",
          options: [{
            name: '全部',
            value: ''
          },{
            name: this.$t('DashboardProduct.barlegendnamefalse'),
            value: 0,
          },{
            name: this.$t('DashboardProduct.barlegendnametrue'),
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Bucket",
          source: "bucket",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '低',
            value: 3,
          },{
            name: '中',
            value: 2,
          },{
            name: '高',
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Authorize",
          source: "authorize",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '是',
            value: 1,
          },{
            name: '否',
            value: 0,
          }],
          default: ''
      }],      
      tableviewQuery: {
        key: "discrimination_report_paging",
        start_date: this.$store.state.startDate+' 00:00:00',
        end_date: this.$store.state.endDate+' 23:59:59',
        industry: "",
        category: "",
        brand: "",
        series: "",
        model: "",
        search: "",
        userid: "",
        page: "1",
        record_per_page: "10",
        rpstatus: "",
        channelids: "",
        discrimnants: "",
        confidence: "",
      },
      tableData: [],
      multipleSelection: [],
      currentPage1: 1,
      pagingtotal: 0,
      DiscriminantResultText: '',
      channelIdAndNameMap: {},
      subid: this.$route.params.Id,
      showecommerce: false,
      currentindex: 9999,
    }
  },

  mounted(){
    let that = this
    this.checkLevel()
    that.requestTabAndDropdownData(that.$route.params.Id)
    that.tableviewModelChange(that.$route.params.Id)
  },

  methods: {

    /**
     * checklevel
     */
    checkLevel: function(){
      let sid = this.$route.params.Id
      let pkglist = JSON.parse(localStorage.getItem("price")).val
      let currentpkg = pkglist.find(o => o.subid/1 === sid/1)
      /**
       * 2：专业版
       * 3：企业版
       */
      let ifshowecommerce = currentpkg.level
      this.showecommerce = ifshowecommerce/1 === 3 ? true : false
    },

    warningDetail: function(sid){
      this.showwaring = true
      this.getSubList(sid)
    },

    shoptags: function(shopname, label, shopid, notes, i){
      this.currentsellername = shopname
      this.textarea = notes
      this.currentshopid = shopid
      this.currentlabe = label
      this.showshopinfo = true
      this.currentindex = i
    },

    setflag: function(label, notes, index, sid){
      let that = this
      that.tableData[index].label = label + 1 < 4 ? label + 1 : 1
      let url = that.API_URL + '/v3/price/shop/edit'
      let postdata= {
        project: that.$route.params.Id/1,
        shopId: sid/1, 
        notes: notes,
        label: that.tableData[index].label
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    setnote: function(label, notes, sid){
      let that = this
      let url = that.API_URL + '/v3/price/shop/edit'
      let postdata= {
        project: this.$route.params.Id/1,
        shopId: sid/1, 
        notes: notes,
        label: label
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
          that.showshopinfo = false
          that.textarea = ''
          that.currentshopid = ''
          that.currentlabe = ''
          // that.tableData[that.currentindex].notes = notes
          let _i = that.currentindex/1
          that.tableData[_i].notes = notes
          console.log('notes', that.tableData[_i].notes)
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    getSubList: function(sid){
      let that = this
      let url = that.API_URL + '/v3/price/shop/getcomplaintInfo?project=' + that.$route.params.Id + '&shopId=' + sid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getSubList', rex)
          let _rex = rex.results
          _rex.forEach(item => {
            item.CreateTime = that.$moment(item.CreateTime).utc().format('YYYY-MM-DD HH:mm')
            item.status = that.setSubStatus(item.status/1)
          })
          that.shopdetaillist = _rex
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    setSubStatus: function(status){
      // 1.待处理 2.处理中 3.平台审核不通过 4.撤销投诉 5.处理成功
      let str = ''
      switch(status){
        case 1:
          str = '待处理'
          break
        case 2:
          str = '处理中'
          break
        case 3:
          str = '平台审核不通过'
          break
        case 4:
          str = '撤销投诉'
          break
        case 5:
          str = '处理成功'
          break
      }
      return str
    },

    /**
     * 查看卖家详情
     */
    viewDetail: function(sid){
      let subid = this.subid
      this.$router.push({name: 'SellerDetail', params: {Id: subid, Sid: sid}}) 
    },

    onTableListSaerch: function(){
      let searchKey = this.viewState.searchNeedle;
      console.log('onTableListSaerch', searchKey)
      let that = this
      that.tableviewModelChange(that.$route.params.Id)
    },

    filters0change: function(val){
      this.filters[0].default = val === '全部' ? '' : val
      console.log(val)
      this.reloadTableData()
    },
    filters1change: function(val){
      this.filterselector[3].default = val === '全部' ? '' : val
      console.log('filters1change', val)
      this.reloadTableData()
    },
    filters2change: function(val){
      let valtxt = ''
      if(val === 1)valtxt = '低风险'
      if(val === 2)valtxt = '中风险'
      if(val === 3)valtxt = '高风险'
      this.filters[2].default = val === '' ? '' : valtxt
      console.log(val)
      this.reloadTableData()
    },

    reloadTableData: function(){
      
      this.tableviewQuery.page = '1'
      this.currentPage1 = 1
      this.channelids = this.filters[0].default
      let that = this
      that.requestTabAndDropdownData(that.$route.params.Id)
      that.tableviewModelChange(that.$route.params.Id)
    },

    resetRefresh: function(){
      this.refresh = false;
    },
    onSelectTab: function(filter,tabid){
      this.viewState.selectedTab = tabid
      this.tableviewQuery.page = '1'
      this.tableviewQuery.rpstatus = filter
      this.currentPage1 = 1
      let that = this
      that.requestTabAndDropdownData(that.$route.params.Id)
      that.tableviewModelChange(that.$route.params.Id)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      let that = this
      that.currentPage1 = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      that.tableviewModelChange(that.$route.params.Id)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.tableviewQuery.page = val
      let that = this
      that.tableviewModelChange(that.$route.params.Id)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    /* 勾选数据行 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let selectionids = this.multipleSelection
      selectionids = selectionids.map(item => {return item.ResultId})
      this.feedbackSelectedIds = selectionids.join(',')
    },

    requestTabAndDropdownData(ids) {
      let that = this
      let url = that.API_URL + '/v3/price/shop/filter'
      let data = {
        start: '',
        end: '',
        subid: ids,
        channel: '',
        series: '',
        model: '',
        search: ''
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('requestTabAndDropdownData', rex)

          //chanel
          if(that.optionsRefresh){
            let selectdefaultval = {
              name : '全部',
              value : ''
            }
            that.filters[0].options = rex.results[0].map(function(val){
              return {
                name: val.Channel,
                value: val.Channel
              }
            })
            
            that.filters[0].options.unshift(selectdefaultval)
            
            that.optionsRefresh = false
          }

        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    tableviewModelChange: function (ids) {

      let that = this

      // active loader
      that.activeTableLoader();
      
      that.tableviewQuery.userid =  localStorage.getItem("userid") && JSON.parse(localStorage.getItem("userid")).val;

      let newQuery = {
        start: '',
        end: '',
        subid: ids,
        page: this.tableviewQuery.page,
        channel: this.filters[0].default,
        authorize: this.filterselector[3].default,
        model: this.filterselector[2].default,
        search: this.viewState.searchNeedle,
        order: this.tableorder,
        size: that.pagesize
      };

      let url = this.API_URL + '/v3/price/shop/paging?shopId=' + this.$route.params.Sid;
      $.ajax({
        url:  url,
        type: "GET",
        data: newQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('#####-----tableviewModelChange',rex)
          let data = rex.results[1]
          data.forEach(
            item => {
              item.ChannelName = that.setChannel(item.Channel).src
              item.pid = ids
              item.Authorize = item.IsAuthor/1
              item.AuthorizeText = item.IsAuthor/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.isQinqText = item.isQinq/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.FakeSku = item.FakeItem
              item.Discriminant = item.ReportLink
              item.RightsProtectionStartTime = item.RightsProtectionTime != "" ? that.$moment(item.RightsProtectionTime).utc().local().format('YYYY-MM-DD HH:mm:ss') : item.RightsProtectionTime
              item.ResultId = item.ShopId
              item.Discount = (item.Discount * 100).toFixed(2) + "%"
              item.ShopLab = item.ShopLab === null ? '' : item.ShopLab === '跨境' ? that.$t('Seller.t8') : that.$t('Seller.t9')
              item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? that.$t('jgjk.s245') + that.formartAmount(item.SkuTotalAmount) : that.$t('jgjk.s246') + that.formartAmount(item.SkuTotalAmount)
              item.label = item.label/1 === 0 || item.label == null ? 1 : item.label/1
              item.shoplevel = item.shoplevel == null || item.shoplevel == '' ? 5 : item.shoplevel/1
            }
          )

          that.tableData = data
          
          that.pagingtotal = rex.results[0][0].Count
					that.$store.state.totalsellers = rex.results[0][0].Count

          that.shutTableLoader()

        },
        error: function(response) {
          console.log(response)
        }
      });
    },
    
    // loader for table 
    activeTableLoader: function() {
      this.tableloading = true
    },
    shutTableLoader: function() {
      this.tableloading = false
    },

    setResults: function(rst){
      let resultobj = {}
      switch (rst) {
        case "1":
          resultobj.styleclass = "btn_tab_pending";
          resultobj.text = this.$t('tabletabs.pending');
          break;
        case "2":
          resultobj.styleclass = "btn_tab_waiting";
          resultobj.text = this.$t('tabletabs.waiting');
          break;
        case "5":
          resultobj.styleclass = "btn_tab_progress";
          resultobj.text = this.$t('tabletabs.progress');
          break;
        case "4":
          resultobj.styleclass = "btn_tab_success";
          resultobj.text = this.$t('tabletabs.success');
          break;
        case "3":
          resultobj.styleclass = "btn_tab_failed";
          resultobj.text = this.$t('tabletabs.failed');
          break;
        default:
          resultobj.styleclass = "btn_tab_all";
          resultobj.text = "";
          break;
      }      
      return resultobj
    },

    /**
     * 自定义排序
     */
    sortTableList: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'ShopName':
            that.tableorder = '00'
            break
          case 'ChannelName':
            that.tableorder = '10'
            break
          case 'shoplevel':
            that.tableorder = '20'
            break
          case 'ShopLab':
            that.tableorder = '30'
            break
          case 'Authorize':
            that.tableorder = '40'
            break
          case 'Discount':
            that.tableorder = '50'
            break
          case 'isQinqText':
            that.tableorder = '60'
            break
          case 'TotalLink':
            that.tableorder = '70'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '80'
            break
          case 'label':
            that.tableorder = '90'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'ShopName':
            that.tableorder = '01'
            break
          case 'ChannelName':
            that.tableorder = '11'
            break
          case 'shoplevel':
            that.tableorder = '21'
            break
          case 'ShopLab':
            that.tableorder = '31'
            break
          case 'Authorize':
            that.tableorder = '41'
            break
          case 'Discount':
            that.tableorder = '51'
            break
          case 'isQinqText':
            that.tableorder = '61'
            break
          case 'TotalLink':
            that.tableorder = '71'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '81'
            break
          case 'label':
            that.tableorder = '91'
            break
        }
      }
      if(column.order == null){
        that.tableorder = ''
      }
      that.reloadTableData()
    },

  }  
}

</script>

<style scoped>
.el-button--text{
  color: #CD454A;
  font-size: 12px;
}
</style>